import {
  Box,
  Button,
  Container,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { DateRangePicker } from "react-date-range";
import { addDays, differenceInCalendarDays, eachDayOfInterval } from "date-fns";
import { CalendarMonth } from "@mui/icons-material";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css";
import CampaignIcon from "@mui/icons-material/Campaign";
import RechartsLineChart from "../CampWiseReport/Charts/RechartsLineChart";
import { useDispatch, useSelector } from "react-redux";
import {
  getPerformanceSitesGraphData,
  getSitesTableDetails,
  performanceSitesData,
} from "../../../redux/features/clicksSlice";
import Datatable from "../../commonLayout/Datatable";
import { calanderDateConverter } from "../../../utils/customDateFunction";
import indianNumberFormatter from "../../../utils/indianNumberFormatter";
import { Helmet } from "react-helmet";

function ClickReport() {
  // start_date, end_date, network, campaign;

  const dispatch = useDispatch();
  const { performSiteData, siteGraphData, siteTableData } = useSelector(
    (state) => state.clicks
  );

  const [dateRanges, setDateRanges] = useState([
    {
      startDate: addDays(new Date(), -14),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [campaign, setCampaign] = useState("");
  const [partner, setPartner] = useState("");
  const [login_id, setLogin_id] = useState("");
  const [toggleCalender, setToggleCalender] = useState(false);
  const [network_pages, setNetwork_pages] = useState(1);
  const [site_pages, setSite_pages] = useState(1);
  const [site, setSite] = useState("");
  const [siteSearchTerm, setSiteSearchTerm] = useState("");

  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 10,
    page: 0,
  });

  // console.log(paginationModel, "paginationModel");
  // let type = "date_wise";
  // if (type == "camp_wise") {
  //   columns = [
  // { field: 'id', headerName: 'ID', width: 70 },

  const total_counts = "Count";
  const total_users = "Users";

  const siteTableDataFilteredRows = siteSearchTerm
    ? siteTableData.filter((row) =>
        row.site.toLowerCase().includes(siteSearchTerm.toLowerCase())
      )
    : siteTableData;

  const columns = React.useMemo(() => [
    {
      field: "site",
      headerName: "Site",
      headerClassName: "mainColor",
      flex: 1,
    },
    {
      field: "total_counts",
      headerName: total_counts,
      headerClassName: "mainColor",
      flex: 1,
      type: "number",
      valueGetter: (value) => {
        if (!value) {
          return value;
        }
        return Number(value.value);
      },
      renderCell: (params) => indianNumberFormatter(params.value),
    },
    {
      field: "total_users",
      headerName: total_users,
      headerClassName: "mainColor",
      flex: 1,
      type: "number",
      valueGetter: (value) => {
        if (!value) {
          return value;
        }
        return Number(value.value);
      },
      renderCell: (params) => indianNumberFormatter(params.value),
    },
  ], []);

  const chartData = React.useMemo(() => {
    return (siteGraphData?.date || []).map((d, i) => ({
      date: d,
      count: siteGraphData?.total_counts?.[i] ?? 0,
    }));
  }, [siteGraphData]);

  const chartProps = React.useMemo(() => ({
    yAxisLeft: { title: "Count", color: "#6366f1" },
    lines: [
      { dataKey: "count", name: total_counts, color: "#6366f1", yAxisId: "left" },
    ]
  }), []);

  useEffect(() => {
    dispatch(
      getPerformanceSitesGraphData({
        start_date: dateConverter(dateRanges[0].startDate),
        end_date: dateConverter(dateRanges[0].endDate),
        site,
      })
    );

    dispatch(
      getSitesTableDetails({
        start_date: dateConverter(dateRanges[0].startDate),
        end_date: dateConverter(dateRanges[0].endDate),
        site,
      })
    );
    dispatch(
      performanceSitesData({
        start_date: dateConverter(dateRanges[0].startDate),
        end_date: dateConverter(dateRanges[0].endDate),
        // site,
      })
    );
  }, [site, dateRanges]);

  // useEffect(() => {
  //   dispatch(
  //     performanceSitesData({
  //       start_date: dateConverter(dateRanges[0].startDate),
  //       end_date: dateConverter(dateRanges[0].endDate),
  //       // site,
  //     })
  //   );
  // }, []);

  const dateConverter = (date) => {
    const arr = date.toString().split(" ");
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const date_str =
      arr[3] + "-" + (months.indexOf(arr[1]) + 1).toString() + "-" + arr[2];
    return date_str;
  };

  const [categories, setCategories] = useState(
    eachDayOfInterval({
      start: dateRanges[0].startDate,
      end: dateRanges[0].endDate,
    }).map((d) => dateConverter(d))
  );

  const handleDateChange = (item) => {
    setDateRanges([
      {
        startDate: item.selection.startDate,
        endDate: item.selection.endDate,
        key: "selection",
      },
    ]);

    const dates = eachDayOfInterval({
      start: item.selection.startDate,
      end: item.selection.endDate,
    }).map((d) => dateConverter(d));
    setCategories(dates);

    setToggleCalender(item.selection.startDate === item.selection.endDate);
  };

  // console.log(site, "site");

  const handleSitePagination = (model) => {
    setPaginationModel(model);
    dispatch(
      getSitesTableDetails({
        start_date: dateConverter(dateRanges[0].startDate),
        end_date: dateConverter(dateRanges[0].endDate),
        site,
        site_pages: model.page + 1,
        searchTerm: siteSearchTerm,
      })
    );
  };

  return (
    <>
      <Helmet>
        <title>Alpha Targeting || ClickReport</title>
      </Helmet>
      <Paper elevation={3}>
        <Container maxWidth="lg">
          <Box>
            <Stack
              direction={"row"}
              gap={2}
              sx={{ pt: 2, display: "flex", justifyContent: "center", alignItems: "center" }}
            >
              <Button
                onClick={() => setToggleCalender(!toggleCalender)}
                startIcon={<CalendarMonth sx={{ color: "#6b7280" }} />}
                variant="outlined"
                sx={{
                  fontWeight: 600,
                  fontSize: "13px",
                  color: "#374151",
                  borderColor: "#e0e0e0",
                  bgcolor: "#fff",
                  textTransform: "none",
                  height: "40px",
                  borderRadius: "8px",
                  px: 2,
                  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                  "&:hover": {
                    borderColor: "#d1d5db",
                    bgcolor: "#f9fafb",
                  }
                }}
              >
                {calanderDateConverter(
                  dateRanges[0].startDate,
                  dateRanges[0].endDate
                )}
              </Button>

              <FormControl sx={{ width: 200 }} size="small">
                <InputLabel id="site" sx={{ fontSize: "13px", color: "#6b7280" }}>Select Site</InputLabel>
                <Select
                  labelId="site"
                  id="site"
                  value={site}
                  label="Select Site"
                  onChange={(e) => setSite(e.target.value)}
                  sx={{
                    height: "40px",
                    borderRadius: "8px",
                    bgcolor: "#fff",
                    fontSize: "13px",
                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#e0e0e0",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#d1d5db",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#9ca3af",
                      borderWidth: "1px",
                    },
                  }}
                >
                  <MenuItem value={""} sx={{ fontSize: "13px" }}>None</MenuItem>
                  {performSiteData &&
                    performSiteData.map((item, index) => (
                      <MenuItem key={item.site} value={`${item.site}`} sx={{ fontSize: "13px" }}>
                        {item.site}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Stack>

            {toggleCalender && (
              <Box>
                <DateRangePicker
                  onChange={(item) => {
                    // console.log(item, "select item");
                    handleDateChange(item);
                  }}
                  showSelectionPreview={true}
                  moveRangeOnFirstSelection={false}
                  months={2}
                  direction="horizontal"
                  ranges={dateRanges}
                />
              </Box>
            )}
            <Box mt={4}>
              <RechartsLineChart
                data={chartData}
                {...chartProps}
              />
            </Box>
          </Box>
          <Datatable
            rows={siteTableDataFilteredRows}
            columns={columns}
            getRowId={(row, index) => `${row.site}-${index}`}
            table_name={"Site Table"}
            // paginationModel={paginationModel}
            // onPaginationModelChange={handleSitePagination}
            // rowCount={total_site_count}
            search={true}
            onSearchTermChange={setSiteSearchTerm}
          />
        </Container>
      </Paper>
    </>
  );
}

export default ClickReport;
